import i18n from '../../locales/index'
import axios from 'axios'
import { filter } from 'lodash';

const state = {
  provinces: [],
  cities: [],
  districts: [],
}

const actions = {
  fetchProvinces: async ({ commit }) => {
    const { data } = await axios.get('areas/provinces')
    commit('setProvinces', data)
  },
  fetchCities: async ({ commit }, provinceId) => {
    const { data } = await axios.get('areas/cities', { params: { province_id: provinceId } })
    commit('setCities', data)
  },
  fetchDistricts: async ({ commit }, cityId) => {
    const { data } = await axios.get('areas/districts', { params: { city_id: cityId } })
    commit('setDistricts', data)
  }
}

const mutations = {
  setProvinces (state, list) {
    state.provinces = filter(list, 'zip_code')
  },
  setCities (state, list) {
    state.cities = filter(list, 'zip_code')
  },
  setDistricts (state, list) {
    state.districts = filter(list, 'zip_code')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
